export const DotGrid = ({ className = "" }: { className?: string }) => (
  <div
    aria-hidden
    className={`pointer-events-none absolute inset-0 ${className}`}
    style={{
      backgroundImage:
        "radial-gradient(circle at 1px 1px, hsl(var(--border) / 0.7) 1px, transparent 0)",
      backgroundSize: "32px 32px",
      maskImage:
        "radial-gradient(ellipse 70% 50% at 50% 30%, black 30%, transparent 75%)",
      WebkitMaskImage:
        "radial-gradient(ellipse 70% 50% at 50% 30%, black 30%, transparent 75%)",
    }}
  />
);

export const GradientOrbs = () => (
  <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
    <div
      className="absolute -top-40 left-1/2 -translate-x-1/2 h-[420px] w-[700px] rounded-full opacity-25 blur-3xl"
      style={{
        background:
          "radial-gradient(closest-side, hsl(var(--primary) / 0.5), transparent)",
      }}
    />
  </div>
);

export const GradientHairline = () => (
  <div
    aria-hidden
    className="h-px w-full"
    style={{
      background:
        "linear-gradient(90deg, transparent, hsl(var(--border)) 20%, hsl(var(--border)) 80%, transparent)",
    }}
  />
);
